<template>
  <ChipBadge :data-testid="dataTestid" :color="color" size="s" rounded>
    <template #prepend>
      <ArrowUpIcon v-if="direction === 'up'" class="lucide-icon-s" aria-hidden="true" />
      <ArrowDownIcon v-else-if="direction === 'down'" class="lucide-icon-s" aria-hidden="true" />
      <MinusIcon v-else class="lucide-icon-s" aria-hidden="true" />
    </template>
    {{ value }}
  </ChipBadge>
</template>

<script lang="ts">
export type InsightsTrendDirection = 'up' | 'down' | 'flat'
</script>

<script setup lang="ts">
import { ChipBadge } from '@ramp106/omrjs-core-ui'
import { ArrowDownIcon, ArrowUpIcon, MinusIcon } from '@ramp106/omrjs-core-ui/icons'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    value: string
    direction: InsightsTrendDirection
    dataTestid?: string
  }>(),
  { dataTestid: 'insights-trend-badge' },
)

const color = computed(() => {
  if (props.direction === 'up') return 'success'
  if (props.direction === 'down') return 'error'
  return 'default'
})
</script>
